import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { languagesService } from 'nallian-shared-ui/lib/services';

const Language = ({ value, languagesFetch }) => {
  const language = useMemo(
    () => (languagesFetch.value || []).find(l => l.id === value)?.name,
    [value, languagesFetch.value]
  );

  return <span>{language}</span>;
};

Language.propTypes = {
  languagesFetch: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
};

export default languagesService(Language);
